import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { TicketData } from '@beat-venues/common-types';
import { Logo, Text } from '../../atoms';
import { useTranslation } from 'next-i18next';
import React, { type JSX } from 'react';

export interface EventListItemProps
    extends CommonProps,
        VariantProps<typeof EventListItemStyles> {
    ticket: TicketData;
}

export const EventListItemStyles = tv({
    slots: {
        logoWrapper: 'flex  shrink-0 items-center pr-2 pb-4',
        logo: 'max-h-full h-6 w-6',
        root: 'font-light leading-6',
        bodyText: 'px-2 text-center pb-4',
    },
    variants: {},
});

export const EventListItem = ({
    className,
    ticket,
    testId = 'event-list-item',
    ...props
}: EventListItemProps): JSX.Element => {
    const { root, logoWrapper, logo, bodyText } = EventListItemStyles();
    const { t } = useTranslation('global');
    return (
        <tr {...props} className={root()}>
            <td className={logoWrapper()}>
                <Logo size="sm" className={logo()} venueId={ticket.venueId} />
            </td>

            {ticket.date && (
                <>
                    <td className={bodyText()}>{ticket.date}</td>
                </>
            )}

            <td className="pb-4 pl-4">
                <div className="relative">
                    <span className="absolute -left-4">•</span>
                    {t(`venues.${ticket.venueId}.name`, {
                        ns: 'global',
                    })}
                </div>
            </td>
        </tr>
    );
};
